import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
    name: 'fileSize',
    standalone: true
})
export class FileSizePipe extends DecimalPipe implements PipeTransform {
  private units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];

  transform(
    value: number | string | string | null | undefined,
    digitsInfo?: string,
    locale?: string
  ): string | null;
  transform(
    value: null | undefined,
    digitsInfo?: string,
    locale?: string
  ): null;
  transform(
    value: number | string | null | undefined,
    digitsInfo?: string,
    locale?: string
  ): string | null {
    if (value == null || value === '' || value !== value) {
      return '-';
    }

    let bytes = this.strToNumber(value);

    let unit = 0;

    while (bytes >= 1024) {
      bytes /= 1024;
      unit++;
    }

    return super.transform(bytes, digitsInfo, locale) + ' ' + this.units[unit];
  }

  /**
   * Transforms a string into a number (if needed).
   */
  strToNumber(value: number | string): number {
    // Convert strings to numbers
    if (
      typeof value === 'string' &&
      !isNaN(Number(value) - parseFloat(value))
    ) {
      return Number(value);
    }
    if (typeof value !== 'number') {
      throw new Error(`${value} is not a number`);
    }
    return value;
  }
}
